var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingapore1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "singapore 1",
    clipPath: "url(#clip0_1626_293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 7.50003C0 3.35789 3.35789 0 7.5 0C11.6421 0 15 3.35789 15 7.50003",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.56523 3.91344C4.56523 2.82072 5.33318 1.90789 6.35869 1.68392C6.20108 1.64952 6.03757 1.63086 5.86955 1.63086C4.60888 1.63086 3.58694 2.65279 3.58694 3.91347C3.58694 5.17414 4.60888 6.19607 5.86955 6.19607C6.03751 6.19607 6.20105 6.17741 6.35869 6.14299C5.33318 5.91901 4.56523 5.00618 4.56523 3.91344Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.50002 1.79297L7.66192 2.29116H8.18578L7.76194 2.5991L7.92383 3.09729L7.50002 2.78941L7.07621 3.09729L7.23811 2.5991L6.8143 2.29116H7.33813L7.50002 1.79297Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.22927 2.77148L6.39113 3.26971H6.91499L6.49118 3.57762L6.65308 4.07581L6.22927 3.76793L5.8054 4.07581L5.96733 3.57762L5.54349 3.26971H6.06735L6.22927 2.77148Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.77081 2.77148L8.93273 3.26971H9.45656L9.03272 3.57762L9.19464 4.07581L8.77081 3.76793L8.347 4.07581L8.50889 3.57762L8.08508 3.26971H8.60891L8.77081 2.77148Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.28167 4.24023L8.44356 4.73846H8.96739L8.54358 5.04637L8.70548 5.54456L8.28167 5.23668L7.85786 5.54456L8.01976 5.04637L7.59595 4.73846H8.11975L8.28167 4.24023Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.71838 4.24023L6.88024 4.73846H7.40413L6.98029 5.04637L7.14221 5.54456L6.71838 5.23668L6.29454 5.54456L6.45643 5.04637L6.03262 4.73846H6.55648L6.71838 4.24023Z",
    fill: "#F0F0F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore1);
export default __webpack_public_path__ + "static/media/singapore 1.c72be3ffdb9e7e52504f78c95e7c3ab8.svg";
export { ForwardRef as ReactComponent };